export const getArrayFilled = (count = 10, min = 0) => {
  return Array.from(Array(count + min).keys());
};
export const getRandomId = () => (Math.random().toString(36) + '00000000000000000').slice(2, 10);

export const formatOutgoingPhoneNumber = (phone: string) => `+98${phone.substring(1)}`;
export const formatIncomingPhoneNumber = (phone: string) => `0${phone.substring(3)}`;
export const phoneNumberToUsername = (phone: string) => `${phone.substring(1)}`;
export const durationToHour = (duration: number) => {
  return duration / 3600000 === 1 ? 'یک ساعت' : 'نیم ساعت';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortData = (data: any, sortColumn: any, sortType: any) => {
  if (sortColumn && sortType) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.sort((a: any, b: any) => {
      const x = a[sortColumn];
      const y = b[sortColumn];
      if (typeof x === 'string') {
        if (sortType === 'asc') {
          return y.localeCompare(x);
        } else {
          return x.localeCompare(y);
        }
      }
      if (sortType === 'asc') {
        return y - x;
      } else {
        return x - y;
      }
    });
  }
  return data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const STATUS_CONVERTOR: any = {
  Pending: 'در انتظار تایید',
  Rejected: 'رد شده',
  Accepted: 'تایید شده'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SESSION_STATUS_CONVERTOR: any = {
  PendingConsultant: 'درانتظار تایید مشاور',
  PendingUser: 'درانتظار تایید کاربر',
  PendingMeeting: 'تایید شده',
  PendingDone: 'زمان و مکان ست شده',
  Done: 'پایان یافته'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ROLE_CONVERTOR: any = {
  User: 'کاربر',
  Admin: 'ادمین',
  Consultant: 'مشاور'
};
